import type { SearchState } from '@/reducers/search';

const wasFirstSearchIdSet = (
  previous: SearchState,
  current: SearchState
): boolean => {
  if (previous.id == null && current.id != null) {
    for (const key in previous) {
      if (
        key !== 'id' &&
        previous[key as keyof SearchState] !== current[key as keyof SearchState]
      ) {
        return false;
      }
    }

    return true;
  } else {
    // The only case we want to catch is when the old ID was null,
    // the new one isn't, and everything else is the same.
    // So if the old and new objects have the same values but with a null search ID,
    // we don't block the update.
    return false;
  }
};

export { wasFirstSearchIdSet };
